import produce from 'immer';
import {State, Actions} from './interfaces';
import {
  GET_DRIVERS,
  GET_DRIVERS_SUCCESS,
  GET_DRIVERS_FAILED,
  GET_CENTERS_FAILED,
  GET_CENTERS,
  GET_CENTERS_SUCCESS,
  GET_VEHICLE_PREFERRED_SOURCES_FAILED,
  GET_VEHICLE_PREFERRED_SOURCES_SUCCESS,
  GET_VEHICLE_PREFERRED_SOURCES,
  GET_DRIVER_SHIFTS,
  GET_DRIVER_SHIFTS_SUCCESS,
  GET_DRIVER_SHIFTS_FAILED,
  CLEAN_DRIVER_LIST,
  GET_DRIVER,
  GET_DRIVER_SUCCESS,
  GET_DRIVER_FAILED,
  GET_DRIVERS_WALLET,
  GET_DRIVERS_WALLET_SUCCESS,
  GET_DRIVERS_WALLET_FAILED,
  GET_DRIVERS_WALLET_TRANSACTION, GET_DRIVERS_WALLET_TRANSACTION_SUCCESS, GET_DRIVERS_WALLET_TRANSACTION_FAILED, ADD_DRIVERS_WALLET_BULK_TRANSACTION, ADD_DRIVERS_WALLET_BULK_TRANSACTION_SUCCESS, ADD_DRIVERS_WALLET_BULK_TRANSACTION_FAILED,
} from './constants';

export const initialState: State = {
  driversList: [],
  driversWalletList: [],
  driversWalletTransactionList: [],
  driver: {},
  driversWalletBulkTransaction: {},
  driversWalletBulkTransactionResult: {},
  centersList: [],
  preferredSourcesLoading: false,
  preferredSources: [],
  driverShifts: {},
  driverShiftsLoading: false,
  count: 0,
  driversWalletTransactionCount: 0,
  sumWallet: 0,
  activeCount: 0,
  deactiveCount: 0,
  loading: false,
  error: '',
};

export const DriversReducer = (state = initialState, action: Actions) =>
  produce(state, draft => {
    switch (action.type) {
      case GET_DRIVERS:
        draft.loading = true;
        break;
      case GET_DRIVERS_SUCCESS:
        draft.driversList = action.data;
        draft.count = action.count;
        draft.activeCount = action.activeCount;
        draft.deactiveCount = action.deactiveCount;
        draft.loading = false;
        break;
      case GET_DRIVERS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_DRIVERS_WALLET_TRANSACTION:
        draft.loading = true;
        break;
      case GET_DRIVERS_WALLET_TRANSACTION_SUCCESS:
        draft.driversWalletTransactionList = action.data;
        draft.driversWalletTransactionCount = action.count;
        draft.loading = false;
        break;
      case GET_DRIVERS_WALLET_TRANSACTION_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case ADD_DRIVERS_WALLET_BULK_TRANSACTION:
        draft.loading = true;
        break;
      case ADD_DRIVERS_WALLET_BULK_TRANSACTION_SUCCESS:
        draft.driversWalletBulkTransaction = action.data;
        draft.driversWalletBulkTransactionResult = action.headers;
        draft.loading = false;
        break;
      case ADD_DRIVERS_WALLET_BULK_TRANSACTION_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_DRIVERS_WALLET:
        draft.loading = true;
        break;
      case GET_DRIVERS_WALLET_SUCCESS:
        draft.driversWalletList = action.data;
        draft.sumWallet = action.count;
        draft.loading = false;
        break;
      case GET_DRIVERS_WALLET_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_DRIVER:
        draft.loading = true;
        break;
      case GET_DRIVER_SUCCESS:
        draft.driver = action.data;
        draft.loading = false;
        break;
      case GET_DRIVER_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_CENTERS:
        draft.loading = true;
        break;
      case GET_CENTERS_SUCCESS:
        draft.centersList = action.data;
        draft.loading = false;
        break;
      case GET_CENTERS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_VEHICLE_PREFERRED_SOURCES:
        draft.preferredSourcesLoading = true;
        break;

      case GET_VEHICLE_PREFERRED_SOURCES_SUCCESS:
        draft.preferredSources = action.data;
        draft.preferredSourcesLoading = false;
        break;
      case GET_VEHICLE_PREFERRED_SOURCES_FAILED:
        draft.error = action.error;
        draft.preferredSourcesLoading = false;
        break;

      case GET_DRIVER_SHIFTS:
        draft.driverShiftsLoading = true;
        break;
      case GET_DRIVER_SHIFTS_SUCCESS:
        draft.driverShifts = action.data;
        draft.driverShiftsLoading = false;
        break;
      case GET_DRIVER_SHIFTS_FAILED:
        draft.error = action.error;
        draft.driverShiftsLoading = false;
        break;
      case CLEAN_DRIVER_LIST:
        draft.error = '';
        draft.driversList = [];
        break;

      default:
        break;
    }
  });
export default DriversReducer;
